<template>
  <v-dialog persistent v-model="dialog" max-width="600" scrollable>
    <v-card v-if="endereco">
      <v-card-title>
        {{ titulo }}
        <v-spacer />
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-select
          v-model="endereco.tipos"
          chips
          deletable-chips
          small-chips
          eager
          multiple
          :items="tiposEndereco"
          label="Tipos"
          hint="Identifique as finalidades deste endereço"
          persistent-hint
        />
        <endereco-form v-model="endereco" obrigatorio />
        <v-switch label="Endereço principal" v-model="endereco.principal" />
        <v-text-field
          v-model="endereco.nome"
          v-touch="endereco.nome"
          label="Identificação do endereço"
          :error-messages="nomeErrors"
          counter="40"
        />
        <v-textarea
          auto-grow
          rows="2"
          v-model="endereco.descricao"
          v-touch="endereco.descricao"
          label="Descrição"
          :error-messages="descricaoErrors"
          counter="140"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="dialog = false">CANCELAR</v-btn>
        <v-btn
          class="primary"
          depressed
          :disabled="$v.$invalid || !endereco.valido"
          @click="salvar()"
        >{{ tituloBotao }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import _ from "lodash";
import { mapState } from "vuex";
import { validationMixin } from "vuelidate";
import { maxLength } from "vuelidate/lib/validators";
import EnderecoForm from "../enderecos/EnderecoForm";
import { unmaskCEP } from "../../lib/masks";

export default {
  components: { EnderecoForm },
  mixins: [validationMixin],
  validations: {
    endereco: {
      nome: { maxLength: maxLength(40) },
      descricao: { maxLength: maxLength(140) }
    }
  },
  computed: {
    dialog: {
      get() {
        return this.$store.state.entidade.enderecoAtivo;
      },
      set(open) {
        if (!open) {
          this.$store.commit("entidade/limparEnderecoAtivo");
        }
      }
    },
    titulo() {
      return this.endereco.id ? "Editar endereco" : "Novo endereco";
    },
    tituloBotao() {
      return this.endereco.id ? "Editar" : "Adicionar";
    },
    nomeErrors() {
      const errors = [];
      if (!this.$v.endereco.nome.$dirty) return errors;
      !this.$v.endereco.nome.maxLength && errors.push("Somente 40 caracteres");
      return errors;
    },
    descricaoErrors() {
      const errors = [];
      if (!this.$v.endereco.descricao.$dirty) return errors;
      !this.$v.endereco.descricao.maxLength &&
        errors.push("Somente 140 caracteres");
      return errors;
    },
    endereco: {
      get() {
        return this.$store.state.entidade.enderecoAtivo;
      },
      set(endereco) {
        this.$store.commit("entidade/editarEndereco", endereco);
      }
    },
    ...mapState({
      tiposEndereco: state => state.entidade.tiposEndereco
    })
  },
  methods: {
    salvar() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        const endereco = _.cloneDeep(this.endereco);
        endereco.cep = unmaskCEP(endereco.cep);
        if (endereco.id) {
          endereco.editar = true;
        } else {
          endereco.novo = true;
        }
        this.$emit("change", endereco);
        this.dialog = false;
      }
    }
  }
};
</script>
